var exports = {
  "pN": "x9245d464--e7e6ff--plate",
  "Qs": "x9245d464--e7e6ff--content",
  "nf": "x9245d464--e7e6ff--link",
};

module.exports = exports;
